const FONT_MSDF = 'msdf';
const FONT_BITMAP = 'bitmap';

export { FONT_BITMAP, FONT_MSDF };
